import React, { Component } from 'react';

import Tile from './Tile';
import './App.css';

class Home extends Component {

  render() {
    return (
        <div className="App-main">
          <Tile text={"About Us!"} url={"/about"} />
          <Tile text={"Projects"} url={"/projects"} />
        </div>
    );
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/Home.js
 **/